import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

/**
 * Get Stores.
 * @param {Array} retailerIdArr
 * @param provinceId
 * @param cityId
 * @returns {Object}
 */
export const storesGet = (retailerIdArr, provinceId, cityId) => {
    provinceId = provinceId ? `provinceId=${provinceId}` : null;
    cityId = cityId ? `cityId=${cityId}` : null;

    const params = [];

    if (retailerIdArr.length) {
        retailerIdArr.forEach(retailerId => {
            params.push(`retailerId=${retailerId}`);
        });
    }

    if (provinceId !== null) {
        params.push(provinceId);
    }
    if (cityId !== null) {
        params.push(cityId);
    }

    params.push("includeInactive=true");

    const query = params.length ? `?${params.join("&")}` : "";
    return axios.get(`${apiUrl}stores${query}`);
};

/**
 * Get store by id.
 * @param {Number} id
 * @returns {Object}
 */
export const storesGetById = (id) =>
    axios.get(`${apiUrl}stores/${id}`);

export const geoLocationByPostalCode = (postalCode) =>
    axios.get(`${apiUrl}latLong/${postalCode}`);

/**
 * Create new store.
 * @param {Object} data
 * @returns {Object}
 */
export const storesCreate = (data) =>
    axios.post(`${apiUrl}stores`, data);

/**
 * Update Store by id.
 * @param {Number} id
 * @param {Object} data
 * @returns {Object}
 */
export const storesUpdate = (id, data) =>
    axios.put(`${apiUrl}stores/${id}`, data);

/**
 * Delete Store by id.
 * @param {Number} id
 * @returns {Object}
 */
export const storesDelete = (id) =>
    axios.delete(`${apiUrl}stores/${id}`);

export const requestStoresImport = (data) =>
    axios.post(`${apiUrl}stores/import`, data);
